import { render, staticRenderFns } from "./CommUploadFile.vue?vue&type=template&id=0066ba39&scoped=true"
import script from "./CommUploadFile.vue?vue&type=script&lang=js"
export * from "./CommUploadFile.vue?vue&type=script&lang=js"
import style0 from "./CommUploadFile.vue?vue&type=style&index=0&id=0066ba39&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0066ba39",
  null
  
)

export default component.exports